import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=6525dc52&scoped=true"
import script from "./CardInfo.vue?vue&type=script&lang=js"
export * from "./CardInfo.vue?vue&type=script&lang=js"
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=6525dc52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6525dc52",
  null
  
)

export default component.exports